import styled from 'styled-components';

import { HeaderStyledProps } from './types';

export const SidenavHeaderWrapper = styled('div')<HeaderStyledProps>`
    width: 100%;
    overflow: hidden;
    position: relative;
    min-height: 8.8rem;
    padding: 0 ${({ isHovered, isExpanded }) => (isHovered || isExpanded ? '2.4rem' : '1.6rem')};
    box-sizing: border-box;
    display: flex;
    align-items: center;

    svg:last-child {
        transition: opacity 200ms;
        opacity: ${({ isHovered, isExpanded }) => (isHovered || isExpanded ? 1 : 0)};
    }

    &::after {
        content: '';
        width: calc(100% - ${({ theme }) => theme.spacing.M3});
        display: block;
        position: absolute;
        border-top: 0.1rem solid ${({ theme }) => theme.colors.grey[900]};
        margin: 0 auto;
        bottom: 0;
        left: 0;
        right: 0;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        display: none;
    }
`;
